import { type PropsWithChildren } from 'react';

import { BrandContext } from '~/modules/branding';
import { BRANDS } from '~/modules/branding/brands';
import { ADA_DOMAINS, WMG_DOMAINS } from '~/modules/branding/constants';
import { ErrorDisplay } from '~/modules/label-perf/containers/LabelPerf/components';

import type { Brand, BrandType } from '../types';

export interface BrandProviderProps {
  localBrand?: BrandType;
  hostname: string;
}

export function BrandProvider({
  children,
  localBrand,
  hostname,
}: PropsWithChildren<BrandProviderProps>) {
  const wmgOneDomains = [...WMG_DOMAINS, localBrand === 'WMG' && 'localhost'];
  const adaHubDomains = [...ADA_DOMAINS, localBrand === 'ADA' && 'localhost'];

  // NOTE: The returned brand object is static so there is no need for useMemo here.
  let brand: Brand | null = null;

  if (adaHubDomains.includes(hostname)) {
    brand = BRANDS.ADA;
  } else if (wmgOneDomains.includes(hostname)) {
    brand = BRANDS.WMG;
  }

  if (!brand) {
    return (
      <ErrorDisplay
        title="Brand Not Found"
        description={`Couldn't determine Brand for localBrand[${localBrand}] and hostname[${hostname}]`}
      />
    );
  }

  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
}

BrandProvider.displayName = 'BrandProvider';
